var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [[_c("el-form", {
    ref: "infoMsg",
    attrs: {
      model: _vm.infoMsg,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "公告ID:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.infoMsg.id) + " ")]), _c("el-form-item", {
    staticStyle: {
      color: "#409EFF"
    },
    attrs: {
      label: "渠道信息:",
      "label-width": "150px"
    }
  }, [_vm._v(" 渠道ID: "), _c("span", {
    staticStyle: {
      color: "#67c23a"
    }
  }, [_vm._v(" " + _vm._s(_vm.infoMsg.channel_id) + " ")]), _vm._v(" 渠道名称："), _c("span", {
    staticStyle: {
      color: "#67c23a"
    }
  }, [_vm._v(_vm._s(_vm.channelMap[_vm.infoMsg.channel_id]))])]), _c("el-form-item", {
    attrs: {
      label: "公告状态:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.status[_vm.infoMsg.status]) + " ")]), _c("el-form-item", {
    attrs: {
      label: "公告类型:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.type[_vm.infoMsg.type]) + " ( 公告" + _vm._s(_vm.pop[_vm.infoMsg.is_pop]) + " ) ")]), _c("el-form-item", {
    attrs: {
      label: "公告标题:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.infoMsg.title) + " ")]), _c("el-form-item", {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      label: "公告内容:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.infoMsg.content) + " ")]), _c("el-form-item", {
    attrs: {
      label: "开始--结束:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.infoMsg.start_time) + " -- " + _vm._s(_vm.infoMsg.end_time) + " ")]), _c("el-form-item", {
    attrs: {
      label: "创建时间:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.infoMsg.create_time) + " ")]), _c("el-form-item", {
    attrs: {
      label: "最后修改信息:",
      "label-width": "150px"
    }
  }, [_vm._v(" 最后修改时间: " + _vm._s(_vm.infoMsg.update_time) + " "), _c("div", {
    staticStyle: {
      color: "#409EFF"
    }
  }, [_vm._v(" 用户ID: "), _c("span", {
    staticStyle: {
      color: "#67c23a"
    }
  }, [_vm._v(_vm._s(_vm.infoMsg.update_user))]), _vm._v(" 用户名： "), _c("span", {
    staticStyle: {
      color: "#67c23a"
    }
  }, [_vm._v(_vm._s(_vm.UserMap[_vm.infoMsg.update_user]))])])])], 1)]], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };